import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { BlurText, HeroBackground, MagneticButton } from './Animations';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  eyebrow?: string;
  headline: string;
  subhead: string;
  primaryCta?: {
    label: string;
    to: string;
  };
  secondaryCta?: {
    label: string;
    to: string;
  };
  graphic?: ReactNode;
  centered?: boolean;
}
export function HeroSection({
  eyebrow,
  headline,
  subhead,
  primaryCta,
  secondaryCta,
  graphic,
  centered = true
}: HeroSectionProps) {
  return <section className={`relative pt-40 pb-20 px-6 md:px-12 max-w-7xl mx-auto ${centered ? 'text-center' : ''}`} data-id="element-266">
      <HeroBackground data-id="element-267" />

      <div className="relative z-10" data-id="element-268">
        {eyebrow && <AnimatedSection data-id="element-269">
            <div className={`text-picus-muted uppercase tracking-widest text-sm mb-6 font-semibold ${centered ? 'flex justify-center' : ''}`} data-id="element-270">
              {eyebrow}
            </div>
          </AnimatedSection>}
        <h1 className={`text-5xl md:text-7xl font-medium leading-tight mb-6 max-w-4xl mx-auto ${centered ? 'justify-center' : ''}`} data-id="element-271">
          <BlurText text={headline} className={centered ? 'justify-center' : ''} data-id="element-272" />
        </h1>

        <AnimatedSection delay={0.3} data-id="element-273">
          <p className="text-lg md:text-xl text-picus-muted max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-274">
            {subhead}
          </p>
        </AnimatedSection>
      </div>

      {(primaryCta || secondaryCta) && <AnimatedSection delay={0.4} className={`relative z-10 flex flex-col sm:flex-row gap-4 ${centered ? 'justify-center' : ''} mb-16`} data-id="element-275">
          {primaryCta && <MagneticButton data-id="element-276">
              <Link to={primaryCta.to} className="inline-flex items-center justify-center px-8 py-3.5 bg-picus-accent text-picus-bg font-medium rounded-full hover:bg-picus-accentHover transition-all hover:scale-105 shadow-[0_0_20px_rgba(0,212,170,0.3)] hover:shadow-[0_0_30px_rgba(0,212,170,0.5)]" data-id="element-277">
                {primaryCta.label}
                <ArrowRight className="ml-2 w-4 h-4" data-id="element-278" />
              </Link>
            </MagneticButton>}
          {secondaryCta && <MagneticButton data-id="element-279">
              <Link to={secondaryCta.to} className="inline-flex items-center justify-center px-8 py-3.5 border border-picus-border text-picus-text font-medium rounded-full hover:bg-picus-surface transition-all hover:scale-105" data-id="element-280">
                {secondaryCta.label}
              </Link>
            </MagneticButton>}
        </AnimatedSection>}

      {graphic && <AnimatedSection delay={0.5} className="relative z-10 mt-12 w-full max-w-5xl mx-auto" data-id="element-281">
          {graphic}
        </AnimatedSection>}
    </section>;
}